/** Reporting-specific subset of process internal keynames used by export/render parity logic. */
export enum ReportingProcessInternalKeyname {
  Chlorination = "$P_CHLORINATION",
  FeFiltration = "$P_FE_FILTRATION",
  Fluoridation = "$P_FLUORIDATION",
  LiquidChlorination = "$P_LIQUID_CHLORINATION",
  Wtp = "$P_WTP",
}

/** Reporting-specific subset of component internal keynames used by export/render parity logic. */
export enum ReportingComponentInternalKeyname {
  FeFilter = "$C_FE_FILTER",
}

/** Site attribute names that legacy and canonical reporting both depend on for footer parity. */
export enum ReportingSiteAttributeName {
  Bacterials = "Bacterials",
  OperatorNumber = "Operator Number",
  PhoneNumber = "Phone Number",
}
